import * as React from "react"
import Svg, { Path } from "react-native-svg"

function UnSelectedRadioButton(props: any) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <Path
                d="M12 22a9.676 9.676 0 01-3.875-.788 10.144 10.144 0 01-3.188-2.15 10.142 10.142 0 01-2.15-3.187A9.676 9.676 0 012 12c0-1.383.263-2.683.788-3.9a9.994 9.994 0 012.15-3.175 10.25 10.25 0 013.187-2.137A9.676 9.676 0 0112 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 013.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0122 12a9.676 9.676 0 01-.788 3.875 10.25 10.25 0 01-2.137 3.188 9.994 9.994 0 01-3.175 2.15A9.738 9.738 0 0112 22zm0-1.5c2.367 0 4.375-.83 6.025-2.488C19.675 16.354 20.5 14.35 20.5 12c0-2.367-.825-4.375-2.475-6.025C16.375 4.325 14.367 3.5 12 3.5c-2.35 0-4.354.825-6.013 2.475C4.33 7.625 3.5 9.633 3.5 12c0 2.35.83 4.354 2.487 6.012C7.646 19.671 9.65 20.5 12 20.5z"
                fill="#80838D"
            />
        </Svg>
    )
}

export default UnSelectedRadioButton
